import { render, staticRenderFns } from "./InfoOperatore.vue?vue&type=template&id=03bfb80a&"
import script from "./InfoOperatore.vue?vue&type=script&lang=ts&"
export * from "./InfoOperatore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports